import { SvgIcon, useTheme } from '@mui/material'

import { Alerts } from 'features/alerts/components/Alerts'
import { AlertData } from 'features/alerts/components/Alerts/types'
import { Alert } from 'features/alerts/types/alert'
import { DomainAmazon } from 'features/globalSetup/features/amazon/types/domainAmazon'
import { DomainAmazonAlert } from 'features/globalSetup/features/amazon/types/domainAmazonAlert'
import UnpluggedIcon from 'images/icons/unplugged.svg?react'

type Props = {
  alerts: DomainAmazon['alerts']
}

export const DomainAmazonAlerts = ({ alerts }: Props): JSX.Element => {
  const theme = useTheme()

  const switcher = (alert: Alert<DomainAmazonAlert>): AlertData | undefined => {
    switch (alert.name) {
      case 'enabled':
        return {
          color: theme.palette.warning.main,
          Icon: (
            <SvgIcon
              component={UnpluggedIcon}
              inheritViewBox
            />
          ),
          tooltip: { text: alert.description },
        }

      default:
        throw Error('Missing alert config')
    }
  }

  return <Alerts<DomainAmazonAlert> {...{ alerts, switcher }} />
}
